import { DialogContent, DialogTitle } from "@mui/material";
import { renderClose } from "../../common/dialog";
import { UseEntityStore } from "../../common/entityStore";
import { CustomerAddressDto, TmOrderDto } from "./common";
import { CustomerAddressList } from "./CustomerAddressList";
import { getResource } from "../../common/localization";

function getText(key: string, defaultMessage?: string) {
    return getResource("Ui.Customer." + key, defaultMessage) as string;
}

export function CustomerAddressListDialog(props: {
    close: () => void;
    useCustomerStore: UseEntityStore<TmOrderDto>;
    disabled: boolean;
    canManageExisting?: false;
    customItemSelect?(item: CustomerAddressDto): void;
}) {
    return <>
        <DialogTitle>{getText("DeliveryAddresses")}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <CustomerAddressList useCustomerStore={props.useCustomerStore} disabled={props.disabled} canManageExisting={props.canManageExisting} customItemSelect={props.customItemSelect ? item => {
                props.customItemSelect!(item);
                props.close();
            } : undefined} />
        </DialogContent>
    </>;
}
